import { capitalize } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/utils';
import { DS_CLASSNAME_MAP } from 'Components/ComponentLibrary/DesignSystem/classNames';

export const DS_SIZE_MAP = {
  xxs: 'xxs',
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  xxl: 'xxl',
  default: 'default',
};

export const DS_SIZES = Object.values(DS_SIZE_MAP);

const buildSizeName = (prefix, sizeName) => {
  const upperFirstLetter = capitalize(sizeName);

  return `${prefix}Size${upperFirstLetter}`;
};

export const buildSizeStyles = (sizes, prefix, buildStyleObj) => {
  return sizes.reduce((acc, curr) => {
    acc[buildSizeName(prefix, curr.name)] = buildStyleObj(curr.config);

    return acc;
  }, {});
};

export const buildSizeObj = (name, config) => {
  return {
    name,
    config,
  };
};

export const buildRootSizeStyles = (sizes, buildStyleObj) => {
  return buildSizeStyles(sizes, DS_CLASSNAME_MAP.root, buildStyleObj);
};

export const matchSize = (classes, sizes, prefix, selectedSize) => {
  return sizes.reduce((acc, curr) => {
    acc[classes[buildSizeName(prefix, curr.name)]] = selectedSize === curr.name;

    return acc;
  }, {});
};

export const matchRootSize = (classes, sizes, selectedSize) => {
  return matchSize(classes, sizes, DS_CLASSNAME_MAP.root, selectedSize);
};

export const getSizeNames = (sizes) => {
  return sizes.map((size) => {
    return size.name;
  });
};
